import styled from 'styled-components';

export const ChatNotificationDot = styled.div`
  width: 15px;
  height: 15px;
  background-color: #d93025;
  border-radius: 50%;
`;
